module.exports = __webpack_public_path__ + "images/7315d2a2b6f7e4d1fcc65a2c7cb7e4d8.png";